class AwardWinnerResults {
  Category = '';

  Title = '';

  campaignTitle = '';

  Brand = '';

  Advertiser= '';

  City = '';

  Awards = '';

  AgencyName = '';

  AgencyNetwork = '';

  campaignSfvId = 0;

  selectedSetId = 0;

  year = 0;

  yearSfvId = 0;

  constructor(data) {
    this.Category = data.category;
    this.Title = data.title;
    this.Brand = data.product;
    this.Advertiser = data.advertiser;
    this.City = data.city;
    this.Awards = data.awards;
    this.AgencyName = data.agencyName;
    this.AgencyNetwork = data.agencyNetwork;
    this.campaignSfvId = data.campaignSfvId;
    this.campaignTitle = data.campaign;
    this.selectedSetId = data.selectedSetId;
    this.year = data.year;
    this.yearSfvId = data.yearSfvId;
  }

  static fromObject(data) {
    return new AwardWinnerResults(data);
  }

  static fromList(list) {
    return (list || []).map(AwardWinnerResults.fromObject);
  }
}

export default AwardWinnerResults;
